<template>
  <div class="layout">
    <!-- 헤더 슬롯 -->
    <slot name="header"></slot>

    <!-- 메인 컨텐츠 (자체 스크롤) -->
    <main class="main-content">
      <slot />
    </main>
  </div>
</template>

<script>
export default {
  name: 'PartnersLayout'
}
</script>

<style scoped>
.layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background-color: #f8fafc;
}

.main-content {
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
}
</style>
